import { h, Component, Fragment, createRef } from "preact";
import PropTypes from "prop-types";
import {
  sendRequest,
  validateEmail,
  validateByPattern,
  formatPriceWithSymbol,
} from "../../tools";
import SelectInput from "./SelectInput";
import TextInput from "./TextInput";
import { calcCommisionBySppsService } from "../../tools";

export default class ServiceFormComplexCertificateNoDebt extends Component {
  static propTypes = {
    urlCreate: PropTypes.string.isRequired,
    urlGetDeliveryZone: PropTypes.string.isRequired,
    urlGetTimeSlot: PropTypes.string.isRequired,
    contracts: PropTypes.array.isRequired,
    cost: PropTypes.number.isRequired,
    products: PropTypes.string.isRequired,
    productName: PropTypes.string.isRequired,
    onSubmited: PropTypes.func,
    typeForm: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
    getSppsDebtsUrl: PropTypes.string,
    serviceIds: PropTypes.array,
    bankCardId: PropTypes.string,
  };

  constructor(props) {
    super(props);

    this.phoneInputRef = createRef();
    this.totalInputRef = createRef();
    this.costEnergyInputRef = createRef();

    this.totalDisplayRef = createRef();
    this.costEnergyDisplayRef = createRef();

    const contract = this.props.contracts[0];
    this.state = {
      values: {
        selectedContractAmount: contract.payAmount,
      },
      date: [],
      timeSlot: [],
      loading: false,
      selectedContract: contract,
      getSppsDebtsUrl: this.props.getSppsDebtsUrl,
      accountServices: [],
      enterUrl: this.props.enterUrl,
      serviceIds: this.props.serviceIds ?? [],
      bankCardId: this.props.bankCards.length
        ? this.props.bankCards[0].id
        : null,
    };
    this.submitted = false;
    this.isSendingRequest = false;
    this.deliveryZoneId = "";
    this.requiredFields = [
      "city",
      "contractGlobalId",
      "street",
      "house",
      "phoneNumber",
      "email",
      "products",
    ];
    this.fieldsName = {
      regPointId: "Номер прибора учета",
      phoneNumber: "Номер телефона",
      email: "E-mail",
      city: "Город",
      contractGlobalId: "Номер договора",
      street: "Улица",
      house: "Дом",
      products: "Услуга",
    };
    this.errorsApi = {};
  }

  clearForm = () => {
    this.submitted = false;
    this.errorsApi = {};
    //this.getDeliveryZone(contract.city, contract.street, contract.house);
    const contract = this.props.contracts[0];
    this.setState({
      date: [],
      timeSlot: [],
      values: {
        phoneNumber: this.props.phone,
        email: this.props.email,
        planeDate: "",
        timeSlot: "",
        paymentType: "",
        products: this.props.products,
        contractGlobalId:
          typeof contract !== "undefined" ? contract.contractGlobalId : "",
        regPointId:
          typeof contract !== "undefined"
            ? contract["meterDevice"].length
              ? contract["meterDevice"][0].serialNumber
              : ""
            : "",
        city: contract.city,
        street: contract.street,
        house: contract.house,
        flat: contract.flat,
        cost: this.props.cost,
        selectedContractAmount: contract.payAmount,
      },
    });
    $(this.phoneInputRef.current).inputmask("setvalue", this.props.phone);
  };

  componentDidMount() {
    const self = this;
    self.addAdditionalClassToBody();
    self.clearForm();
    const contract = this.props.contracts[0];
    window.addEventListener("load", () => self.fetchSppsDebts(contract));
    //self.fetchSppsDebts(contract)
    $(this.phoneInputRef.current).inputmask({
      mask: "+7 (999) 999 9999",
      clearIncomplete: true,
      oncomplete: function (e) {
        self.setValues({ phoneNumber: e.target.value });
      },
      onincomplete: function () {
        self.setValues({ phoneNumber: "" });
      },
    });
  }

  addAdditionalClassToBody() {
    const body = document.querySelector("body");
    body.classList.add("ajax-loader-hidden");
  }

  fetchSppsDebts(contract) {
    const accountId = contract.accountId;
    sendRequest(this.props.getSppsDebtsUrl, {
      body: { accountId: accountId, excludeContractServices: false },
      showLoader: true,
    })
      .then((response) => {
        if (response.status >= 500 || response.status === 0) {
          $.disMsg(
            "Произошла неизвестная ошибка во время выполнения запроса.</br> Пожалуйста, обратитесь в техподдержку.",
            { type: "false" }
          );
          return;
        }
        switch (response.status) {
          case 200:
            let items = response.data.items;
            this.setState({
              accountServices: this.filterServices(items),
            });
            this.setTotalAmount(this.filterServices(items));
            break;

          case 404:
            $.disMsg(
              "Произошла неизвестная ошибка во время выполнения запроса.</br> Пожалуйста, обратитесь в техподдержку.",
              { type: "false" }
            );
            break;

          default:
            throw new Error(
              `Status ${response.status}. Status text: ${response.statusText}`
            );
        }
      })
      .catch((error) => Form.showRequestError(error));
  }

  filterServices(items) {
    var serviceIds = [];
    if (this.state.serviceIds.length > 0) {
      serviceIds = this.state.serviceIds;
    }
    var filteredItems = [];
    for (let i = 0; i < items.length; i++) {
      if (serviceIds.indexOf(items[i].serviceId) != -1) {
        filteredItems.push(items[i]);
      }
    }
    return filteredItems;
  }

  setTotalAmount(items) {
    let servicesTotal = 0;
    for (let item of items) {
      servicesTotal += item.totalAmount;
    }

    const total =
      this.props.cost +
      servicesTotal +
      parseFloat(this.state.selectedContract.payAmount);
    const totalForServices =
      servicesTotal + parseFloat(this.state.selectedContract.payAmount);
    this.setValues({
      total: total,
      totalForServices: totalForServices,
    });
  }

  render(props, state, context) {
    const errors = { ...this.errorsApi, ...this.validate() };
    const contract =
        this.props.contracts.find(
          (item) => item.contractGlobalId === state.values.contractGlobalId
        ) || [],
      meterDevices = "meterDevice" in contract ? contract.meterDevice : [];
    const meterDevice = meterDevices.find(
      (item) => item.serialNumber === state.values.regPointId
    );
    let phase = "";
    const canEnterMeterReadings = true;
    const nesName = this.props.nesName
      ? this.props.nesName
      : "АО «НовосибирскЭнергосбыт»";
    const { values } = this.state;
    const total = values.total;
    const selectedContractAmount = values.selectedContractAmount;
    return (
      <form className="form">
        <div className="form__body">
          <div className="form__title-2">{props.productName}</div>
          <div className="form__fieldset">
            <div
              className={`form-field__input-row ${
                "city" in errors || "street" in errors || "house" in errors
                  ? "form-field_state_error"
                  : ""
              }`}
            >
              <SelectInput
                onChange={this.onChangeAddress}
                defaultValue=""
                name="address"
                checkedItem={state.values.contractGlobalId}
                getItemName={(item) => item.address}
                getItemValue={(item) => item.contractGlobalId}
                items={this.props.contracts}
                isCheckedValue={(item) =>
                  item.contractGlobalId === state.values.contractGlobalId
                }
              />
            </div>
          </div>

          <div className="form__fieldset">
            <div className="form__fieldset-title">Контактные данные</div>
            <div className="form__item form__item_horizontal">
              <div
                className={`form-field form-field_gray ${
                  errors.phoneNumber ? "form-field_state_error" : ""
                }`}
              >
                <div className="form-field__inner">
                  <div className="form-field__title-row">
                    <label className="form-field__title" htmlFor="phoneNumber">
                      {this.isRequired("phoneNumber")}Номер телефона
                    </label>
                  </div>
                  <div className="form-field__input-row">
                    <input
                      className="input form-field__input"
                      type="text"
                      id="phoneNumber"
                      ref={this.phoneInputRef}
                    />
                  </div>
                </div>
              </div>
              <TextInput
                errors={errors.email}
                isRequired={this.isRequired("email")}
                name="Почта"
                inputProps={{
                  onChange: this.onChangeInput("email"),
                  value: state.values.email,
                  placeholder: "Введите почту",
                  id: "email",
                }}
              />
            </div>
          </div>

          <div className="form__fieldset">
            <div className="form__item">
              {canEnterMeterReadings && (
                <div className="form-field form-field_gray">
                  <div className="form-info-block__item form-info-block__item-service">
                    <div className="form-info-block__name">
                      <label className="form-field__title">
                        {this.isRequired("regPointId")} {nesName}
                      </label>
                    </div>
                    <div
                      className={`form-info-block__value ${
                        errors.regPointId ? "form-field_state_error" : ""
                      }`}
                    >
                      <button
                        className="button-primary button-primary_pdv_sm debt-table-item-2__counter-btn"
                        data-modal-url={this.state.selectedContract.enterUrl}
                      >
                        <span className="button-primary__text">
                          Передать показания
                        </span>
                        <span
                          className="button-primary__icon button-primary__icon_sz_sm js__tooltip"
                          title="Передача показаний необходима для точного расчета задолженности"
                        ></span>
                      </button>
                      <span
                        ref={this.costEnergyDisplayRef}
                        id="cost-energy"
                        className="form-info-block__value-inner"
                      >
                        {formatPriceWithSymbol(selectedContractAmount)}
                      </span>
                      <input
                        ref={this.costEnergyInputRef}
                        id="amount-energy"
                        name="amount-energy"
                        value={selectedContractAmount}
                        type="hidden"
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
            {this.state.accountServices &&
              this.state.accountServices.map((service) => {
                return (
                  <div className="form__item">
                    <div className="form-field form-field_gray">
                      <div className="form-info-block__item form-info-block__item-service">
                        <div className="form-info-block__name">
                          <p className="form-field__title">
                            {service.providerName}
                          </p>
                          <p className="form-field__title">
                            {service.serviceName}
                          </p>
                        </div>
                        <div
                          className={`form-info-block__value ${
                            errors.regPointId ? "form-field_state_error" : ""
                          }`}
                        >
                          {formatPriceWithSymbol(service.totalAmount)}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            <div className="form__item">
              <div className="form-field form-field_gray">
                <div className="form-info-block__item form-info-block__item-service">
                  <div className="form-info-block__name">
                    <p className="form-field__title">Стоимость услуги</p>
                  </div>
                  <div className="form-info-block__value">
                    {formatPriceWithSymbol(this.props.cost)}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {meterDevices.length > 1 && (
            <div className="form__item">
              <div className="form-field form-field_gray">
                <div className="form-field__inner">
                  <div className="form-field__title-row">
                    <label className="form-field__title">
                      {this.isRequired("regPointId")}Серийный номер прибора
                      учета, по которому нужно оказать услугу
                    </label>
                  </div>
                  <div
                    className={`form-field__input-row ${
                      errors.regPointId ? "form-field_state_error" : ""
                    }`}
                  >
                    {
                      <SelectInput
                        onChange={this.onChangeInput("regPointId")}
                        name="regPointId"
                        items={meterDevices}
                        checkedItem={state.values.regPointId}
                        placeholder={state.values.regPointId}
                        getItemName={(item) => item.serialNumber}
                        getItemValue={(item) => item.serialNumber}
                        isCheckedValue={(item) =>
                          item.serialNumber === state.values.regPointId
                        }
                      />
                    }
                  </div>
                </div>
              </div>
            </div>
          )}
          {phase}

          <div className="form__fieldset">
            <div className="form__item">
              <div className="form-field form-field_gray">
                <div className="form-info-block__item form-info-block__item-service">
                  <div className="form__fieldset-title">
                    Сумма задолженности по поставщикам услуг:
                  </div>
                  <div
                    ref={this.totalDisplayRef}
                    id="cost-total"
                    className="form__fieldset-title form-info-block__value"
                  >
                    {total && formatPriceWithSymbol(total)}
                  </div>
                  <input
                    ref={this.totalInputRef}
                    name="amount-total"
                    id="amount-total"
                    value={total}
                    type="hidden"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="form__footer">
          {!!errors &&
            Object.values(errors).map((item) => {
              return <p className="form__error-text">{item}</p>;
            })}
          <button
            onClick={this.onSubmitForm}
            disabled={Object.keys(errors).length || this.state.loading}
            className="button-primary button-primary_pdv_lg form__submit-btn"
          >
            {this.state.loading
              ? "Отправка заявки"
              : "Оплатить и направить заявку"}
          </button>
        </div>
      </form>
    );
  }

  validate = () => {
    let errors = {};
    const self = this;
    if (!this.submitted) return errors;

    const { values } = this.state;

    this.requiredFields.forEach((requiredField) => {
      if (
        typeof values[requiredField] === "undefined" ||
        values[requiredField] === null ||
        values[requiredField].length === 0
      ) {
        const fieldName =
          requiredField in self.fieldsName
            ? self.fieldsName[requiredField]
            : "";
        errors[requiredField] = `"${fieldName}" обязательно для заполнения`;
      }
    });

    const pattern = /[^а-яА-ЯёЁ\-\s]+$/g;

    errors = {
      ...errors,
      ...validateByPattern(values.lastName, pattern, "lastName", "Фамилия"),
    };
    errors = {
      ...errors,
      ...validateByPattern(values.firstName, pattern, "firstName", "Имя"),
    };
    errors = {
      ...errors,
      ...validateByPattern(values.surname, pattern, "surname", "Отчество"),
    };

    if (values.email && !validateEmail(values.email)) {
      errors.email = "E-mail заполнен неверно";
    }
    if (values.totalForServices && values.totalForServices > 0) {
      //errors.debt = 'Для получения справки оплатите долг';
    }

    return errors;
  };

  isRequired = (fieldName) =>
    this.requiredFields.indexOf(fieldName) !== -1 ? "* " : "";

  getTimeSlot = (planeDate) => {
    this.setState({ timeSlot: [] });
    if (this.deliveryZoneId.length === 0 || planeDate.length === 0) return;
    const formData = new FormData();
    formData.append("deliveryZone", this.deliveryZoneId);
    formData.append("datePlan", planeDate);

    sendRequest(this.props.urlGetTimeSlot, {
      body: formData,
      type: "POST",
      showLoader: true,
    }).then((data) => {
      if (data.status >= 500 || data.status === 0) {
        $.disMsg(
          "Произошла неизвестная ошибка во время выполнения запроса.</br> Пожалуйста, обратитесь в техподдержку.",
          { type: "false" }
        );
        return;
      }
      if (data.data) {
        this.setState({ timeSlot: data.data });
      }
    });
  };

  getPlaneDate = () => {
    this.setState({ date: [], timeSlot: [] });
    if (this.deliveryZoneId.length === 0) return;
    const formData = new FormData();
    formData.append("deliveryZone", this.deliveryZoneId);

    sendRequest(this.props.urlGetPlaneDate, {
      body: formData,
      type: "POST",
      showLoader: true,
    }).then((data) => {
      if (data.status >= 500 || data.status === 0) {
        $.disMsg(
          "Произошла неизвестная ошибка во время выполнения запроса.</br> Пожалуйста, обратитесь в техподдержку.",
          { type: "false" }
        );
        return;
      }
      if (data.data) {
        this.setState({
          date: data.data.filter((date) => {
            if (date.available) {
              const newDate = new Date(date.year, date.month - 1, date.day);
              const now = new Date();
              const maxDate = new Date(
                now.getFullYear(),
                now.getMonth(),
                now.getDate() + 3
              );

              return newDate >= maxDate;
            }

            return false;
          }),
          timeSlot: [],
        });
      }
    });
  };

  getDeliveryZone = (city, street, house) => {
    if (city.length === 0 || street.length === 0 || house.length === 0) return;
    const formData = new FormData();
    formData.append("city", city);
    formData.append("street", street);
    formData.append("home", house);

    sendRequest(this.props.urlGetDeliveryZone, {
      body: formData,
      type: "POST",
      showLoader: true,
    }).then((data) => {
      if (data.status >= 500 || data.status === 0) {
        $.disMsg(
          "Произошла неизвестная ошибка во время выполнения запроса.</br> Пожалуйста, обратитесь в техподдержку.",
          { type: "false" }
        );
        return;
      }
      if (data.data) {
        this.deliveryZoneId = data.data;
        this.getPlaneDate();
      } else {
        this.deliveryZoneId = "";
        this.setState({ date: [], timeSlot: [] });
      }
    });
  };

  onChangeDatePlane = (e) => {
    this.setValues({
      planeDate: e.target.value,
      timeSlot: "",
    });
    this.getTimeSlot(e.target.value);
  };

  onChangeAddress = (e) => {
    const contract = this.props.contracts.find(
      (item) => item.contractGlobalId === e.target.value
    );
    this.resetAmounts();
    this.setValues({
      contractGlobalId: e.target.value,
      regPointId: contract.meterDevice.length
        ? contract.meterDevice[0].serialNumber
        : "",
      planeDate: "",
      timeSlot: "",
    });
    this.setState({
      selectedContract: contract,
    });
    this.setValues({
      selectedContractAmount: contract.payAmount,
    });
    this.fetchSppsDebts(contract);
  };

  onChangeInput = (field) => (e) => {
    this.setAmountsFromInputs();
    this.setValues({ [field]: e.target.value });
  };

  setValues = (values) => {
    this.removeErrorsApi(values);
    this.setState((state, props) => ({
      values: {
        ...state.values,
        ...values,
      },
    }));
  };

  removeErrorsApi = (fields) => {
    const self = this;
    Object.keys(fields).map((field) => {
      if (field in self.errorsApi) {
        delete self.errorsApi[field];
      }
    });
  };

  setAmountsFromContract = () => {
    this.totalDisplayRef.current.innerHTML = "";
    this.costEnergyDisplayRef.current.innerHTML = "";
    if (
      parseFloat(this.costEnergyInputRef.current.value) >
      parseFloat(this.state.values.selectedContractAmount)
    ) {
      this.setValues({
        selectedContractAmount: this.state.selectedContract.payAmount,
      });
    }
  };

  resetAmounts = () => {
    console.log("resetAmounts", null);
    this.totalDisplayRef.current.innerHTML = "";
    this.costEnergyDisplayRef.current.innerHTML = "";
    this.setValues({
      selectedContractAmount: this.state.selectedContract.payAmount,
      total: "",
    });
  };

  setAmountsFromInputs = () => {
    this.totalDisplayRef.current.innerHTML = "";
    this.costEnergyDisplayRef.current.innerHTML = "";
    if (
      parseFloat(this.costEnergyInputRef.current.value) >
      parseFloat(this.state.values.selectedContractAmount)
    ) {
      this.setValues({
        selectedContractAmount: this.costEnergyInputRef.current.value,
        total: this.totalInputRef.current.value,
      });
    }
  };

  onSubmitForm = (e) => {
    e.preventDefault();
    if (this.isSendingRequest) return;
    this.isSendingRequest = true;
    const self = this;
    this.submitted = true;
    this.setAmountsFromInputs();
    const errors = this.validate();
    if (Object.keys(errors).length || Object.keys(self.errorsApi).length) {
      this.isSendingRequest = false;
      this.forceUpdate();
      return;
    }

    this.setState({ loading: true });

    const formData = new FormData();
    const { values } = this.state;
    const contract = this.props.contracts.find(
      (item) => item.contractGlobalId === values.contractGlobalId
    );

    let meterDevice = contract.meterDevice.find(
      (item) => item.serialNumber === values.regPointId
    );
    if (!meterDevice) {
      meterDevice = {
        name: "Нет данных",
        regPointId: values.regPointId,
      };
    }
    formData.append("typeForm", "formComplexCertificateNoDebt");
    formData.append("contractGlobalId", values.contractGlobalId);
    formData.append("city", values.city);
    formData.append("street", values.street);
    formData.append("house", values.house);
    formData.append("flat", values.flat);
    formData.append("regPointId", meterDevice.regPointId);
    formData.append("regPointName", meterDevice.name);
    formData.append("phoneNumber", values.phoneNumber);
    formData.append("email", values.email);
    formData.append("products[]", values.products);
    formData.append("cost", values.cost);

    var amountEnergy = 0;
    const selectedContract = this.state.selectedContract;
    const contractAmounts = this.getSirenaContractAmounts(selectedContract);
    if (contractAmounts.debt > 0 || contractAmounts.fine > 0) {
      amountEnergy =
        this.costEnergyInputRef.current.value &&
        this.costEnergyInputRef.current.value > contractAmounts.debt
          ? this.costEnergyInputRef.current.value
          : contractAmounts.debt;
    }

    sendRequest(this.props.urlCreate, {
      body: formData,
      type: "POST",
      headers: { contentType: false, processData: false },
      showLoader: true,
    }).then((data) => {
      if (data.status === 200) {
        this.createOrder(amountEnergy);
        this.clearForm();
        if (typeof self.props.onSubmited === "function") {
          self.props.onSubmited();
        }
      }

      if (data.status === 422) {
        JSON.parse(data.data).map((item) => {
          self.errorsApi[item["field"]] = item.message;
        });
      }
      if (data.status >= 500 || data.status === 0) {
        $.disMsg(
          "Произошла неизвестная ошибка во время выполнения запроса.</br> Пожалуйста, обратитесь в техподдержку.",
          { type: "false" }
        );
      }
      //this.createOrder();
    }).finally(() => {
        self.setState({ loading: false });
        self.isSendingRequest = false;
      });
  };

  createOrder(amountEnergy = 0) {
    const self = this;
    const { accountServices } = this.state;
    //const props = this.props;

    const data = {
      items: [],
      bankCardId: this.state.bankCardId,
    };

    const addDataItem = function (
      accountId,
      sppsServiceId,
      amount,
      debtAccountId,
      type = "spps_service"
    ) {
      data.items.push({
        accountId,
        sppsServiceId,
        type: type,
        amount,
        debtAccountId,
      });
    };

    //const {values} = this.state;
    //const contract = this.props.contracts.find(item => item.contractGlobalId === values.contractGlobalId);
    const contract = this.state.selectedContract;
    const { accountId, contractId } = contract;
    data.items.push({
      accountId,
      contractId,
      type: "sirena_contract",
      amount: this.props.cost,
      fineAmount: 0,
    });
    const contractAmounts = this.getSirenaContractAmounts(contract);
    if (contractAmounts.debt > 0 || contractAmounts.fine > 0) {
      data.items.push({
        accountId,
        contractId,
        type: "sirena_contract",
        amount: amountEnergy,
        fineAmount: contractAmounts.fine,
      });
    }

    if (accountServices.length > 0) {
      accountServices.forEach((sppsService) => {
        const accountId = sppsService.sirenaAccountId;
        const serviceId = sppsService.serviceId;
        const debtAccountId = sppsService.accountId;
        const isPlan = sppsService.debtServiceInfo.isPlan ?? 0;

        const debtAmounts = self.getSppsServiceAmounts(sppsService);

        if (debtAmounts.debt > 0 || debtAmounts.plan) {
          let amount = 0;

          if (isPlan === 0) {
            amount += Math.max(0, parseFloat(debtAmounts.debt) || 0);
            amount += Math.max(0, parseFloat(debtAmounts.plan) || 0);
          } else {
            amount += Math.max(0, parseFloat(debtAmounts.plan) || 0);
          }

          if (amount > 0) {
            addDataItem(
              accountId,
              sppsService.serviceId,
              amount,
              debtAccountId
            );
          }
        }

        if (sppsService.fineServiceId && debtAmounts.fine > 0) {
          addDataItem(
            accountId,
            sppsService.fineServiceId,
            debtAmounts.fine,
            debtAccountId
          );
        }
      });
    }

    if (!data.items.length) {
      // $.disMsg('Выберите услуги для оплаты', {type: 'false'});
      // return false;
    }

    sendRequest(this.props.createOrderUrl, {
      body: data,
      type: "POST",
      showLoader: true,
    })
      .then((response) => {
        switch (response.status) {
          case 200:
            const order = response.data;
            if (order.id) {
              if (window.ajaxIndicatior) window.ajaxIndicatior.show();
              window.location = order.paymentUrl;
            } else
              throw new Error(
                `Status 200. Status text: Ошибка создания заказа`
              );
            break;

          default:
            throw new Error(
              `Status ${response.status}. Status text: ${response.statusText}`
            );
        }
      })
      .catch((error) => Form.showRequestError(error));
  }

  getSirenaContractAmounts(contract) {
    const amounts = {
      debt: parseFloat(contract.payAmount),
      fine: contract.fineAmount ? parseFloat(contract.fineAmount) : 0,
      comission: 0,
      total: 0,
    };

    if (contract.sppsServiceDebtInfo) {
      amounts.debt = Math.max(0, amounts.debt);
    }

    if (contract.sppsServiceFineInfo) {
      amounts.fine = Math.max(0, amounts.fine);
    }

    if (contract.sppsServiceDebtInfo) {
      amounts.comission += calcCommisionBySppsService(
        parseFloat(amounts.debt) || 0,
        contract.sppsServiceDebtInfo
      );
    }

    if (contract.sppsServiceFineInfo) {
      amounts.comission += calcCommisionBySppsService(
        parseFloat(amounts.fine) || 0,
        contract.sppsServiceFineInfo
      );
    }

    amounts.total =
      Math.max(0, parseFloat(amounts.debt) || 0) +
      Math.max(0, parseFloat(amounts.fine) || 0) +
      amounts.comission;

    return amounts;
  }

  getSppsServiceAmounts(debt) {
    const { customAmounts } = this.state;

    const amounts = {
      debt: debt.debtAmount,
      fine: debt.fineAmount || 0,
      plan: debt.planAccruals || 0,
      planComission: 0,
      comission: 0,
      total: 0,
    };

    const isSelectedSppsPlanAccrualsService = debt.debtServiceInfo.isPlan;

    if (debt.debtServiceInfo) {
      if (customAmounts !== undefined) {
        const customDebtAmount =
          customAmounts[
            this.getKeyAmountInput(
              debt.sirenaAccountId,
              debt.serviceId,
              debt.accountId
            )
          ];
        if (customDebtAmount !== undefined) {
          amounts.debt = customDebtAmount;
        } else {
          amounts.debt = Math.max(0, amounts.debt);
        }
      } else {
        amounts.debt = Math.max(0, amounts.debt);
      }
    }

    if (debt.fineServiceId && debt.fineServiceInfo) {
      if (customAmounts !== undefined) {
        const customFineAmount =
          customAmounts[
            this.getKeyAmountInput(
              debt.sirenaAccountId,
              debt.fineServiceId + "_" + debt.serviceId,
              debt.accountId
            )
          ];
        if (customFineAmount !== undefined) {
          amounts.fine = customFineAmount;
        } else {
          amounts.fine = Math.max(0, amounts.fine);
        }
      } else {
        amounts.fine = Math.max(0, amounts.fine);
      }
    }

    if (isSelectedSppsPlanAccrualsService) {
      if (debt.debtServiceInfo) {
        const customPlanAmount =
          customAmounts[
            this.getKeyAmountInput(
              debt.sirenaAccountId,
              debt.serviceId,
              debt.accountId,
              1
            )
          ];
        if (customPlanAmount !== undefined) {
          amounts.plan = customPlanAmount;
        } else amounts.plan = Math.max(0, amounts.plan);
      }
    }

    if (debt.debtServiceInfo) {
      amounts.comission += calcCommisionBySppsService(
        parseFloat(amounts.debt) || 0,
        debt.debtServiceInfo
      );
      amounts.planComission += calcCommisionBySppsService(
        parseFloat(amounts.plan) || 0,
        debt.debtServiceInfo
      );
    }

    if (debt.fineServiceId && debt.fineServiceInfo) {
      amounts.comission += calcCommisionBySppsService(
        parseFloat(amounts.fine) || 0,
        debt.fineServiceInfo
      );
    }

    amounts.total =
      (!isSelectedSppsPlanAccrualsService || isSelectedSppsService
        ? Math.max(0, parseFloat(amounts.debt) || 0)
        : 0) +
      (!isSelectedSppsPlanAccrualsService || isSelectedSppsService
        ? Math.max(0, parseFloat(amounts.fine) || 0)
        : 0) +
      (isSelectedSppsPlanAccrualsService
        ? Math.max(0, parseFloat(amounts.plan) || 0)
        : 0) +
      (!isSelectedSppsPlanAccrualsService || isSelectedSppsService
        ? amounts.comission
        : 0) +
      (isSelectedSppsPlanAccrualsService ? amounts.planComission : 0);

    return amounts;
  }

  getKeyAmountInput(
    accountId,
    serviceId,
    debtAccountId = undefined,
    isPlan = 0
  ) {
    let key = accountId + "#" + serviceId;

    if (typeof debtAccountId !== "undefined") {
      key += "#" + debtAccountId;
    }
    if (isPlan !== 0) {
      key += "#" + isPlan;
    }

    return key;
  }

  isSelectedSppsService = (accountId, serviceId, debtAccountId, isPlan = 0) => {
    return (
      this.state.accountServices.findIndex(
        (debt) =>
          debt.serviceId === serviceId &&
          debt.debtAccountId === debtAccountId &&
          debt.sirenaAccountId === accountId &&
          debt.isPlan === isPlan
      ) !== -1
    );
  };
}
